import { useEffect } from "react";

export function usePageTitle(title) {
    useEffect(() => {
        if (!title) return;

        const prev = document.title;
        document.title = title;

        return () => {
            document.title = prev; // restore on unmount
        };
    }, [title]);
}